import React from 'react';
import InputField from '../../Forms/Input/InputField';
import TextAreaField from '../../Forms/Input/TextAreaField';
import { ProductFormValues } from '../../../types/product/ProductFormValues';
import { useProduct } from '../../../hooks/useProduct';

interface Props {
  form: ProductFormValues;
  onChange: (field: keyof ProductFormValues, value: any) => void;
}

const ProductBasicInfo: React.FC<Props> = ({ form, onChange }) => {
  const { formErrors } = useProduct();

  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
      <h3 className="text-gray-800 col-span-1 text-lg font-semibold dark:text-white md:col-span-2">
        Datos del Producto
      </h3>

      <InputField
        label="Nombre:"
        name="name"
        type="text"
        iconKey="edit"
        value={form.name}
        onChange={(e) => onChange('name', e.target.value)}
        placeholder="Ingrese el nombre del producto"
        error={formErrors.name}
        required
      />

      {/* Código (solo lectura) */}
      {form.id != null && (
        <InputField
          label="Código:"
          name="code"
          iconKey="barcode"
          type="text"
          value={form.code || ''}
          onChange={() => {}}
          error={formErrors.code}
          disabled
        />
      )}

      <InputField
        label="Precio de venta:"
        name="price"
        type="number"
        iconKey="dollar"
        step="0.01"
        min={0}
        value={form.price}
        onChange={(e) => onChange('price', parseFloat(e.target.value))}
        placeholder="Ejemplo: 12.50"
        error={formErrors.price}
        required
      />

      {/* ✅ Precio mínimo de venta */}
      <InputField
        label="Precio mínimo permitido:"
        name="minimumSalePrice"
        type="number"
        iconKey="priceDown"
        step="0.01"
        min={0}
        value={form.minimumSalePrice ?? ''}
        onChange={(e) =>
          onChange('minimumSalePrice', parseFloat(e.target.value))
        }
        placeholder="Ej: 10.00"
        error={formErrors.minimumSalePrice}
        required
      />

      <div className="md:col-span-2">
        <TextAreaField
          label="Descripción:"
          name="description"
          value={form.description ?? ''}
          onChange={(e) => onChange('description', e.target.value)}
          placeholder="Describa brevemente el producto"
          iconKey="edit"
          error={formErrors.description}
        />
      </div>
    </div>
  );
};

export default ProductBasicInfo;
